//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import querystring from "@/js/querystring";
import {
    getStorage,
    getThemeByType,
    getEnv,
    getFormData,
    queryFormat,
    setNavigation,
    addWhiteList,
} from "@/js/utils";
import sendVerCodeBtn from "@/components/SendVerCodeBtn";
import { SUCCESS_CODE } from "@/service/httpCode";
import selfInput1 from "@/components/SelfInput1";
import sendVertificationCode from "@/components/SendVertificationCode";

export default {
    name: "prephone",
    components: { sendVerCodeBtn, selfInput1, sendVertificationCode },
    data() {
        return {
            returnUrl: "",
            bankcardtel: "",
            bankcardvcode: "",
            nextBtnText: "确定",
            tradeID: "",
            userBank: {},
            isDisabled: false,
            themeType: "default",
            isLoading: false,
            bindX: false,
            sourceTitle: false,
            formData: {
                action: "",
                params: [],
            },
            isVertificationCodeShow: false,
        };
    },
    computed: {
        isCMBSigning() {
            const bizType = getEnv();
            return bizType == "Loan" || bizType == "Koo";
        },
    },

    async created() {
        if (this.$route.query.source === "bindcard") {
            const { userBank, returnUrl, themeType, bindX, sourceTitle } =
                getStorage("session", "changeMobileParams");
            this.userBank = userBank;
            this.returnUrl = returnUrl;
            this.themeType = themeType;
            this.bindX = bindX;
            this.sourceTitle = sourceTitle;

            // 签约跳转回来页面数据初始化，并且轮训签约结果
            const { tradeId } = this.$route.query;
            if (tradeId) {
                this.tradeID = tradeId;
                this.getSignPageInit();

                this.signProcessing();
            }

            this.$bus.$emit("update-title", {
                hasHeader: this.sourceTitle,
                title: "更换预留手机号",
                noClose: this.bindX === false,
            });
        } else {
            this.showTheLoading(async () => {
                const {
                    mobile,
                    smallIconUrl,
                    returnUrl,
                    themeType,
                    bankName,
                    cardNum,
                    userBankAccountId,
                    bindX,
                    sourceTitle,
                } = await this.doRequest("changeMobileLoad", {
                    orderNum: this.$store.orderNo,
                });
                this.bindX = bindX;
                this.sourceTitle = sourceTitle;
                this.userBank = {
                    smallIconUrl,
                    bankName,
                    cardNum,
                    mobile,
                    userBankAccountId,
                };
                this.returnUrl = returnUrl;
                this.themeType = getThemeByType(themeType || "0");

                // 签约跳转回来页面数据初始化，并且轮训签约结果
                const { tradeId } = this.$route.query;
                if (tradeId) {
                    this.tradeID = tradeId;
                    this.getSignPageInit();

                    this.signProcessing();
                }

                this.$bus.$emit("update-title", {
                    hasHeader: this.sourceTitle,
                    title: "更换预留手机号",
                    noClose: this.bindX === false,
                });
            }, "isLoading");
        }
    },

    mounted() {
        addWhiteList();
    },

    methods: {
        next() {
            if (!this.check()) return;

            this.sendVertificationCode();

            // this.showTheLoading(async () => {
            //     // 提交后按钮不可点
            //     this.isDisabled = true;
            //     const { data, result } = await this.$http.confirmChangeMobile({
            //         orderNum: this.$store.orderNo,
            //         tradeID: this.tradeID,
            //         verifyCode: this.bankcardvcode,
            //     });

            //     if (result === SUCCESS_CODE) {
            //         location.href = this.returnUrl;
            //     }
            //     this.isDisabled = false;
            // });
        },

        confirmChangeMobile() {
            this.showTheLoading(async () => {
                // 提交后按钮不可点
                this.isDisabled = true;
                const { data, result } = await this.$http.confirmChangeMobile({
                    orderNum: this.$store.orderNo,
                    tradeID: this.tradeID,
                    verifyCode: this.bankcardvcode,
                });
                if (result === SUCCESS_CODE) {
                    location.href = this.returnUrl;
                }
                this.isDisabled = false;
            });
        },

        async sendVertificationCode() {
            this.$vux.loading.show();
            const { data, result } = await this.$http.applyChangeMobile({
                mobile: this.bankcardtel.replace(/\s/g, ""),
                orderNum: this.$store.orderNo,
                userBankAccountId: this.userBank.userBankAccountId,
                callbackUrl: this.getSignReturnUrl(),
            });
            if (result === SUCCESS_CODE) {
                this.tradeID = data.tradeID;

                // 绑卡签约逻辑
                if (this.isCMBSigning) {
                    const { redirectUrl, redirectToken, signTag } = data;

                    if (signTag) {
                        // 如果签约成功，直接跳转
                        location.href = this.returnUrl;
                    } else if (redirectUrl) {
                        // 组装form表单提交宝付地址
                        this.formData.action = redirectUrl;
                        this.formData.params = getFormData(redirectToken);
                        this.$nextTick(() => {
                            // setNavigation({
                            //     navParams: {
                            //         fullScreen: "1",
                            //         visible: "2",
                            //         leftView: [],
                            //         titleView: {},
                            //         rightView: {},
                            //     },
                            //     title: "更换预留手机号",
                            // });
                            this.$refs.submitBtn.click();
                        });
                    } else {
                        // 短信验证
                        this.isVertificationCodeShow = true;
                    }
                } else {
                    this.isVertificationCodeShow = true;
                }
            }
            this.$vux.loading.hide();
            return result;
        },
        check() {
            if (!this.bankcardtel) {
                this.$vux.toast.show({
                    type: "text",
                    text: "手机号码不能为空",
                    width: "50%",
                });
                return false;
            }

            let telReg = /^(13|14|15|16|17|18|19)[0-9]{9}$/;
            if (!this.bankcardtel.replace(/\s/g, "").match(telReg)) {
                this.$vux.toast.show({
                    type: "text",
                    text: "请输入正确的手机号码",
                    width: "50%",
                });
                return false;
            }

            // if (!this.bankcardvcode) {
            //     this.$vux.toast.show({
            //         type: "text",
            //         text: "验证码不能为空",
            //         width: "50%",
            //     });
            //     return false;
            // }
            // if (this.bankcardvcode.length !== 6) {
            //     this.$vux.toast.show({
            //         type: "text",
            //         text: "请输入正确的验证码",
            //         width: "50%",
            //     });
            //     return false;
            // }
            // if (!this.tradeID) {
            //     this.$vux.toast.show({
            //         type: "text",
            //         text: "请重新获取验证码",
            //         width: "50%",
            //     });
            //     return false;
            // }

            return true;
        },

        signProcessing() {
            // 轮训签约结果
            this.querySignResult();
            this.timer = setTimeout(() => {
                this.clearTimer();
                if (this.statusCode == 200) {
                    location.href = this.returnUrl;
                }
            }, 10000);
            this.queryTimer = setInterval(async () => {
                this.querySignResult();
            }, 3000);
        },

        async querySignResult() {
            // 请求签约结果
            this.loadingTimer = setTimeout(() => {
                this.$vux.loading.show();
                clearTimeout(this.loadingTimer);
            }, 0);
            const { data, result } = await this.$http.bindConfirm({
                tradeID: this.tradeID,
                orderNum: this.$store.orderNo,
            });

            if (result === SUCCESS_CODE) {
                const { statusCode } = data;
                this.statusCode = statusCode;

                if (statusCode === 200) {
                    this.clearTimer();
                    location.href = this.returnUrl;
                }
            }
        },

        clearTimer() {
            clearInterval(this.queryTimer);
            clearTimeout(this.timer);
            this.$vux.loading.hide();
        },

        vertificationCodeCallback(vcode) {
            if (vcode && vcode.length == 6) {
                this.bankcardvcode = vcode;
                this.confirmChangeMobile();
            }
        },

        getSignReturnUrl() {
            const { orderNo } = this.$store;

            const params = {
                ord: orderNo,
                // m: this.bankcardtel,
                source: this.$route.query.source,
            };

            return (
                location.origin + location.pathname + "?" + queryFormat(params)
            );
        },

        getSignPageInit() {
            // const { m } = this.$route.query;
            // this.bankcardtel = m;
        },
    },
};
